import React from 'react';
import { View,Text } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

const recusado =()=>{
    return(
    <View style={{backgroundColor:'#01150E',height:'100%',width:'100%'}}>
    <View style={{margin:10,flexDirection:'row'}}> 
    <Ionicons name="ios-checkmark-circle" size={30} color="white" />
    <Text style={{color:'white'}}>Se seu cartão foi recusado verifique se possui o saldo necessário, para a transação confira os dados, se estiver tudo ok ligue na operadora do seu cartão e informe que esta tentando fazer uma TRANSAÇÃO online e seu cartao esta sendo recusado.</Text>  
    </View>
    </View>
    );

}
export default recusado;